// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== CALCULATOR CARD ===== */


/* ===== HEADER (BADGE LEFT / TITLE RIGHT) ===== */

.calculator-header {
  text-align: center;
  justify-content: space-between;
  align-items: center;
  margin-top: -25px;
}

.calculator-title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #0f172a;
  margin-top:-13px;
}

.calculator-badge img {
  max-width: 155px;
  height: auto;
}

/* ===== MONTHLY PAYMENT ===== */

.calculator-payment-block {
  margin-top: -20px;
  text-align: center;
}

.monthly-main {
  font-size: 38px;
  font-weight: 800;
  color: #0f172a;
}

.monthly-sub {
  font-size: 15px;
  font-weight: 600;
  margin-top: 2px;
  color: #475569;
}

/* ===== INPUT BLOCKS ===== */

.calculator-fields {
  width: 100%;
  margin-bottom: -25px;
}

.calculator-row {
  margin-bottom: 18px;
}

.field-label-bold {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
}

.slider-value-top {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #334155;
}

.slider {
  width: 100%;
  cursor: pointer;
}

/* ===== TEXT INPUTS / ERRORS (ZIP + CREDIT) ===== */

.calculator-text-input {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
  color: #0f172a;
  background: #f8fafc;
  box-sizing: border-box;
}

.calculator-text-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 1px rgba(37,99,235,0.25);
}

.calculator-error {
  margin-top: 4px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #b91c1c;
}

/* ===== CTA ===== */

.calculator-cta {
  background: linear-gradient(180deg, #2563eb, #1e40af);
  color: #ffffff;
  border: none;
  padding: 15px 18px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  box-shadow: 0 6px 18px rgba(37,99,235,0.35);
}

.calculator-cta-full {
  width: 100%;
  margin-bottom: 15px;
}

html[data-brand="house-helper"] .calculator-text-input:focus {
  border-color: #2f7d32;
  box-shadow: 0 0 0 1px rgba(47, 125, 50, 0.25);
}

html[data-brand="house-helper"] .calculator-cta {
  background: linear-gradient(180deg, #7cc243, #2f7d32);
  box-shadow: 0 6px 18px rgba(47, 125, 50, 0.28);
}

/* ====================================================================
   VALUE PROPS LAYOUT FIXES (WHERE CALCULATOR LIVES)
   ==================================================================== */


/* FULL WIDTH IMAGE BELOW THE CARD */
.cl-featureImageWrapBottom {
      margin-top: 12px;
    text-align: center;
    justify-self: center;
    width: 98%;
}

@media (min-width: 450px) {


.cl-featureImageBottom {
  border-radius: 14px;
    display: block;
    width: 85%;
}


  .cl-valueLeft {
    margin-top: -110px;
  }

  .calculator-card {
      background: #ffffff;
    border-radius: 18px;
    padding: 22px 26px;
    max-width: 280px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-self: center;
}

 
}

/* ====================================================================
   MOBILE FIXES (THE KEY BUG YOU WERE SEEING)
   ==================================================================== */



@media (max-width: 550px) {


.cl-featureImageBottom {
          border-radius: 14px;
        display: inline;
        width: 100%;
        margin-left: 0px;
}

  .calculator-card {
            background: #ffffff;
        width: 100%;
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        justify-self: center;
        padding-top: 22px;
        padding-right: 26px;
        padding-bottom: -8px;
        padding-left: 26px;
        
        
    }
    .cl-ProjectCostCalculator{
      justify-self: center;
        margin-left: 20px;
        margin-right: 20px;
    }


  .cl-valueLeft {
            margin-top: 53px;
        justify-self: center;
        width: 95%;

  }
  

}



@media (max-width:550px) {

  .cl-featureImageBottom {
      
        border-radius: 14px;
        justify-self: left;
        width: 96%;
  }
}

@media (min-width:550px) {


  .calculator-card {
            background: #ffffff;
        width: 230px;
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        justify-self: center;
        padding-top: 22px;
        padding-right: 17px;
        padding-bottom: 11px;
        padding-left: 17px;
        margin-right: -15px; 
        
    }

    .cl-ProjectCostCalculator{
      justify-self: center;
      margin-left: 10px;
      
      
                list-style: none;
        padding-bottom: 5px;
        margin-left: 0px;
        display: grid;
        
        margin-right: 36px;
        height: fit-content;
        }


  .cl-featureImageBottom {
      
        border-radius: 14px;
        margin-left: 3px;
        justify-self: left;
        width: 100%;
  }

  .calculator-payment-block {

      
    text-align: center;
  }

  /* Force the estimator & checklist to stack vertically */
  .cl-twoCol {
    flex-direction: column;
    gap: 28px;
  }

  .cl-valueLeft {
         margin-top: 0px;
        justify-self: left;
        width: 102%;
        margin-left: -25px;
  }
 



  .calculator-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .calculator-title {
    text-align: center;
  }

  .monthly-main {
    font-size: 32px;
  }
}

/* ===== APR TOOLTIP (SAFE, NO LAYOUT IMPACT) ===== */

.tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.tooltip-icon {
  font-size: 15px;
  cursor: pointer;
  color: #475569; /* subtle slate color */
}

.tooltip-box {
  position: absolute;
  top: 22px;
  left: 0;
  background: #1e293b;
  color: #ffffff;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
  width: 220px;
  display: none;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0,0,0,0.18);
}

.tooltip-container:hover .tooltip-box {
  display: block;
}
/* === Term Row (safe inline layout) === */

.term-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.term-select {
  width: 100px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  font-size: 14px;
  color: #0f172a;
}
/* === Monthly Payment Animation === */

.monthly-main {
  transition: transform 0.35s ease, opacity 0.35s ease;
}

/* Triggered when the payment updates */
.monthly-main.animate-payment {
  transform: scale(1.15);
  opacity: 0.4;
}



.cl-ProjectCostCalculator.no-featured {
  margin-top: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/ProjectCalculator.css"],"names":[],"mappings":"AAAA,gCAAgC;;;AAGhC,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,gCAAgC;;AAEhC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;;AAE7B;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,oDAAoD;;AAEpD;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;;yEAEyE;;;AAGzE,oCAAoC;AACpC;MACM,gBAAgB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA;;;AAGA;EACE,mBAAmB;IACjB,cAAc;IACd,UAAU;AACd;;;EAGE;IACE,kBAAkB;EACpB;;EAEA;MACI,mBAAmB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;AACxB;;;AAGA;;AAEA;;yEAEyE;;;;AAIzE;;;AAGA;UACU,mBAAmB;QACrB,eAAe;QACf,WAAW;QACX,gBAAgB;AACxB;;EAEE;YACU,mBAAmB;QACvB,WAAW;QACX,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;QACpB,kBAAkB;;;IAGtB;IACA;MACE,oBAAoB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;;;EAGF;YACU,gBAAgB;QACpB,oBAAoB;QACpB,UAAU;;EAEhB;;;AAGF;;;;AAIA;;EAEE;;QAEM,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;EAChB;AACF;;AAEA;;;EAGE;YACU,mBAAmB;QACvB,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;;IAEvB;;IAEA;MACE,oBAAoB;MACpB,iBAAiB;;;gBAGP,gBAAgB;QACxB,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;;QAEb,kBAAkB;QAClB,mBAAmB;QACnB;;;EAGN;;QAEM,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;EACjB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;SACO,eAAe;QAChB,kBAAkB;QAClB,WAAW;QACX,kBAAkB;EACxB;;;;;EAKA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;AACA,0CAA0C;;AAE1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA,sCAAsC;;AAEtC;EACE,oDAAoD;AACtD;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,YAAY;AACd;;;;AAIA;EACE,gBAAgB;AAClB","sourcesContent":["/* ===== CALCULATOR CARD ===== */\n\n\n/* ===== HEADER (BADGE LEFT / TITLE RIGHT) ===== */\n\n.calculator-header {\n  text-align: center;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: -25px;\n}\n\n.calculator-title {\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n  color: #0f172a;\n  margin-top:-13px;\n}\n\n.calculator-badge img {\n  max-width: 155px;\n  height: auto;\n}\n\n/* ===== MONTHLY PAYMENT ===== */\n\n.calculator-payment-block {\n  margin-top: -20px;\n  text-align: center;\n}\n\n.monthly-main {\n  font-size: 38px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.monthly-sub {\n  font-size: 15px;\n  font-weight: 600;\n  margin-top: 2px;\n  color: #475569;\n}\n\n/* ===== INPUT BLOCKS ===== */\n\n.calculator-fields {\n  width: 100%;\n  margin-bottom: -25px;\n}\n\n.calculator-row {\n  margin-bottom: 18px;\n}\n\n.field-label-bold {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 6px;\n}\n\n.slider-value-top {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: #334155;\n}\n\n.slider {\n  width: 100%;\n  cursor: pointer;\n}\n\n/* ===== TEXT INPUTS / ERRORS (ZIP + CREDIT) ===== */\n\n.calculator-text-input {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n  color: #0f172a;\n  background: #f8fafc;\n  box-sizing: border-box;\n}\n\n.calculator-text-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px rgba(37,99,235,0.25);\n}\n\n.calculator-error {\n  margin-top: 4px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #b91c1c;\n}\n\n/* ===== CTA ===== */\n\n.calculator-cta {\n  background: linear-gradient(180deg, #2563eb, #1e40af);\n  color: #ffffff;\n  border: none;\n  padding: 15px 18px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  width: 100%;\n  box-shadow: 0 6px 18px rgba(37,99,235,0.35);\n}\n\n.calculator-cta-full {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\nhtml[data-brand=\"house-helper\"] .calculator-text-input:focus {\n  border-color: #2f7d32;\n  box-shadow: 0 0 0 1px rgba(47, 125, 50, 0.25);\n}\n\nhtml[data-brand=\"house-helper\"] .calculator-cta {\n  background: linear-gradient(180deg, #7cc243, #2f7d32);\n  box-shadow: 0 6px 18px rgba(47, 125, 50, 0.28);\n}\n\n/* ====================================================================\n   VALUE PROPS LAYOUT FIXES (WHERE CALCULATOR LIVES)\n   ==================================================================== */\n\n\n/* FULL WIDTH IMAGE BELOW THE CARD */\n.cl-featureImageWrapBottom {\n      margin-top: 12px;\n    text-align: center;\n    justify-self: center;\n    width: 98%;\n}\n\n@media (min-width: 450px) {\n\n\n.cl-featureImageBottom {\n  border-radius: 14px;\n    display: block;\n    width: 85%;\n}\n\n\n  .cl-valueLeft {\n    margin-top: -110px;\n  }\n\n  .calculator-card {\n      background: #ffffff;\n    border-radius: 18px;\n    padding: 22px 26px;\n    max-width: 280px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    justify-self: center;\n}\n\n \n}\n\n/* ====================================================================\n   MOBILE FIXES (THE KEY BUG YOU WERE SEEING)\n   ==================================================================== */\n\n\n\n@media (max-width: 550px) {\n\n\n.cl-featureImageBottom {\n          border-radius: 14px;\n        display: inline;\n        width: 100%;\n        margin-left: 0px;\n}\n\n  .calculator-card {\n            background: #ffffff;\n        width: 100%;\n        border-radius: 18px;\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        justify-self: center;\n        padding-top: 22px;\n        padding-right: 26px;\n        padding-bottom: -8px;\n        padding-left: 26px;\n        \n        \n    }\n    .cl-ProjectCostCalculator{\n      justify-self: center;\n        margin-left: 20px;\n        margin-right: 20px;\n    }\n\n\n  .cl-valueLeft {\n            margin-top: 53px;\n        justify-self: center;\n        width: 95%;\n\n  }\n  \n\n}\n\n\n\n@media (max-width:550px) {\n\n  .cl-featureImageBottom {\n      \n        border-radius: 14px;\n        justify-self: left;\n        width: 96%;\n  }\n}\n\n@media (min-width:550px) {\n\n\n  .calculator-card {\n            background: #ffffff;\n        width: 230px;\n        border-radius: 18px;\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        justify-self: center;\n        padding-top: 22px;\n        padding-right: 17px;\n        padding-bottom: 11px;\n        padding-left: 17px;\n        margin-right: -15px; \n        \n    }\n\n    .cl-ProjectCostCalculator{\n      justify-self: center;\n      margin-left: 10px;\n      \n      \n                list-style: none;\n        padding-bottom: 5px;\n        margin-left: 0px;\n        display: grid;\n        \n        margin-right: 36px;\n        height: fit-content;\n        }\n\n\n  .cl-featureImageBottom {\n      \n        border-radius: 14px;\n        margin-left: 3px;\n        justify-self: left;\n        width: 100%;\n  }\n\n  .calculator-payment-block {\n\n      \n    text-align: center;\n  }\n\n  /* Force the estimator & checklist to stack vertically */\n  .cl-twoCol {\n    flex-direction: column;\n    gap: 28px;\n  }\n\n  .cl-valueLeft {\n         margin-top: 0px;\n        justify-self: left;\n        width: 102%;\n        margin-left: -25px;\n  }\n \n\n\n\n  .calculator-header {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .calculator-title {\n    text-align: center;\n  }\n\n  .monthly-main {\n    font-size: 32px;\n  }\n}\n\n/* ===== APR TOOLTIP (SAFE, NO LAYOUT IMPACT) ===== */\n\n.tooltip-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.tooltip-icon {\n  font-size: 15px;\n  cursor: pointer;\n  color: #475569; /* subtle slate color */\n}\n\n.tooltip-box {\n  position: absolute;\n  top: 22px;\n  left: 0;\n  background: #1e293b;\n  color: #ffffff;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  width: 220px;\n  display: none;\n  z-index: 9999;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.18);\n}\n\n.tooltip-container:hover .tooltip-box {\n  display: block;\n}\n/* === Term Row (safe inline layout) === */\n\n.term-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.term-select {\n  width: 100px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n  color: #0f172a;\n}\n/* === Monthly Payment Animation === */\n\n.monthly-main {\n  transition: transform 0.35s ease, opacity 0.35s ease;\n}\n\n/* Triggered when the payment updates */\n.monthly-main.animate-payment {\n  transform: scale(1.15);\n  opacity: 0.4;\n}\n\n\n\n.cl-ProjectCostCalculator.no-featured {\n  margin-top: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
